import React from 'react';
import Img from '../images/background-mini.jpg'
export const downloadsLinks = [
  {
    id: 0,
    title: 'Un día normal',
    author: 'LíBERTI',
    url: 'https://firebasestorage.googleapis.com/v0/b/liberti-501c2.appspot.com/o/liberti-un-dia-normal.mp3.zip?alt=media&token=f1eac564-c643-4ccd-af4f-4198725f7753',
    cover: `${Img}`,
  }
];
const fetchedPlaylist = [
  {
    id: 0,
    title: 'Un día normal',
    author: 'LíBERTI',
    url: 'https://firebasestorage.googleapis.com/v0/b/liberti-501c2.appspot.com/o/liberti-un-dia-normal.mp3?alt=media&token=d9e7c481-a1b5-4815-a0c3-333e277c8f3c',
    cover: `${Img}`,
  }
];

// mock api request
export const fetchPlaylist = () => {
  return new Promise((res, rej) => {
    setTimeout(() => res(fetchedPlaylist), 1000);
  });
};

export const PlaylistContext = React.createContext();
